export const TestIds = {
  root: 'imageX',
  scrollEffectStyle: 'scrollEffectStyle',
};
